export const LOGIN_SERVER_SUCCESS = "LOGIN_SERVER_SUCCESS";
export const LOGIN_SERVER_FAILED = "LOGIN_SERVER_FAILED";
export const LOGOUT_SERVER_SUCCESS = "LOGOUT_SERVER_SUCCESS";

export const LOGIN_FIREBASE_SUCCESS = "LOGIN_FIREBASE_SUCCESS";
export const LOGIN_FIREBASE_FAILED = "LOGIN_FIREBASE_FAILED";
export const LOGOUT_FIREBASE_SUCCESS = "LOGOUT_FIREBASE_SUCCESS";
export const SAVE_FIREBASE_AUTH = "SAVE_FIREBASE_AUTH";
